// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".convo-card-footer[data-v-458aea76]{display:flex;align-items:center;margin-top:.8rem}.convo-card-footer__text[data-v-458aea76]{margin-left:5px}.posted-date[data-v-458aea76]{display:flex;align-items:center;font-family:\"Rawline\",sans-serif;font-size:1.2rem;color:#9a93a7;white-space:nowrap}.posted-date-icon[data-v-458aea76]{margin-right:5px;color:#9a93a8}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
